import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c5ec696c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "complements"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "complements__title" }, "Materiais de apoio", -1))
const _hoisted_3 = { class: "complements__list" }
const _hoisted_4 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.complements?.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.complements, (complement, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: 'complement-' + index,
              class: _normalizeClass([
          'complements__item',
          {
            file: complement.type === _ctx.ComplementaryContentType.PDF
          },
          {
            link: complement.type === _ctx.ComplementaryContentType.URL
          }
        ])
            }, [
              _createElementVNode("a", {
                class: "complements__link",
                href: complement.url,
                target: "_blank"
              }, _toDisplayString(complement.name), 9, _hoisted_4)
            ], 2))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}